// extracted by mini-css-extract-plugin
module.exports = {"paginationStyle":"MUITable_paginationStyle__7_jQN","container":"MUITable_container__318Jq"};